import * as React from 'react'

import { useProductData } from '@grandvisionhq/fun-products'

import { ReserveInStoreButton } from '../reserve-in-store-button'

export const ReserveInStoreGraphContainer = () => {
  const { activeVariant } = useProductData()

  return <ReserveInStoreButton sku={activeVariant.sku} />
}
